import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]

interface Props {
	type?: 'div' | 'fieldset';
	showError?: boolean;
	isMaxWidthField?: boolean;
	inputId: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FieldContainer',
  props: {
    type: { default: 'div' },
    showError: { type: Boolean, default: false },
    isMaxWidthField: { type: Boolean },
    inputId: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.type), {
    class: "field-container flow",
    "data-error": __props.showError ? true : null,
    "data-max-width": __props.isMaxWidthField ? true : null
  }, {
    default: _withCtx(() => [
      (_ctx.$slots.label)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.type === 'div')
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  for: __props.inputId
                }, [
                  _renderSlot(_ctx.$slots, "label")
                ], 8, _hoisted_1))
              : (_openBlock(), _createElementBlock("legend", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "label")
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.$slots[ 'help-text' ])
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            id: `${__props.inputId}-help-text`
          }, [
            _renderSlot(_ctx.$slots, "help-text")
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "field"),
      (_ctx.$slots.error)
        ? (_openBlock(), _createElementBlock("p", {
            key: 2,
            class: "field-container__error-text",
            id: `${__props.inputId}-error`
          }, [
            _renderSlot(_ctx.$slots, "error")
          ], 8, _hoisted_4))
        : _createCommentVNode("", true),
      (!__props.showError && _ctx.$slots.message)
        ? (_openBlock(), _createElementBlock("p", {
            key: 3,
            class: "field-container__message",
            id: `${__props.inputId}-message`
          }, [
            _renderSlot(_ctx.$slots, "message")
          ], 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["data-error", "data-max-width"]))
}
}

})